module.exports = "https://www.gc-pro.gnp.com.mx/89f3869bb33e117c4f66ebb7aa24495b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/otp/2.png
// module id = 1037
// module chunks = 0 1